import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Cards } from 'src/components/cards/Cards';
import { Triangle, TriangleDown } from 'src/utils/mdIcons';
import { formatNumber } from 'src/utils/formatters';


const useStyles = makeStyles(theme => ({
  trendIcon: {
    fontSize: '12px',
  },
  variationUp: {
    color: theme.palette.success.main,
  },
  variationDown: {
    color: theme.palette.error.main,
  },
}));

const surfaceTypes = {
  totalDisturbed: 'Superficie total perturbada',
  totalRehabilitatedRestoredConserved: 'Superficie total perturbada',
};

const SpatialFootprintTable = ({ data }) => {
  const classes = useStyles();

  const tableData = Object.keys(data).reduce((acc, type, index) =>
    ([ ...acc, { id: index + 1, surfaceType: surfaceTypes[type], year2020: data[type]['2020'], year2024: data[type]['2024'] } ]), []);

  return (
    <Cards
      values={tableData}
      columns={[
        {
          title: 'Superficie',
          field: 'surfaceType',
          headerTextAlign: 'center',
          render: item => (
            <Box textAlign="center" fontWeight={600}>
              {item.surfaceType}
            </Box>
          ),
        },
        {
          title: 'Año 2020 [Ha]',
          field: 'year2020',
          headerTextAlign: 'center',
          render: item => (
            <Box textAlign="center">
              {formatNumber(item.year2020, 1)}
            </Box>
          ),
        },
        {
          title: 'Año 2024 [Ha]',
          field: 'year2024',
          headerTextAlign: 'center',
          render: item => (
            <Box textAlign="center">
              {formatNumber(item.year2024, 1)}
            </Box>
          ),
        },
        {
          title: 'Cambio',
          field: 'change',
          headerTextAlign: 'center',
          render: item => {
            const change = item.year2024 - item.year2020;
            let changePercent = item.year2020 > 0 ? ((change / item.year2020) * 100).toFixed(1) : 0;
            changePercent = String(changePercent).replace('.', ',');
            return (
              <Box textAlign="center">
                {change > 0 ? <Triangle className={clsx(classes.trendIcon, classes.variationUp)} />
                : change < 0 ? <TriangleDown className={clsx(classes.trendIcon, classes.variationDown)} />
                : null
                }
                <Typography
                  variant="body2"
                  className={clsx({
                    [classes.variationUp]: change > 0,
                    [classes.variationDown]: change < 0,
                  })}
                  component="span"
                >
                  &nbsp;{change > 0 ? '+' : change < 0 ? '-' : ''}{formatNumber(Math.abs(change), 1)} ({changePercent}%)
                </Typography>
              </Box>
            );
          },
        },
      ]}
      variant="condensed"
    />
  );
};

SpatialFootprintTable.propTypes = {
  data: PropTypes.shape({
    totalDisturbed: PropTypes.shape({
      '2020': PropTypes.number,
      '2024': PropTypes.number,
    }),
    totalRehabilitatedRestoredConserved: PropTypes.shape({
      '2020': PropTypes.number,
      '2024': PropTypes.number,
    }),
  }).isRequired,
};


export {
  SpatialFootprintTable,
};
